import { createApiCall } from 'lib/base';
import { generateEndpoint } from 'utils/urlHelpers';

const FETCH_NHSV_RIGHTS_HISTORY_API_ID =
  'DASHBOARD/FETCH_NHSV_RIGHTS_HISTORY_API';

export const NHSV_RIGHT_TYPES = [
  'upcoming',
  'dividend',
  'bonus-share',
  'issue',
  'conversion',
  'other',
  'bond',
  'bond-interest',
] as const;

export type NHSVRightType = typeof NHSV_RIGHT_TYPES[number];

const apiCall = createApiCall(
  FETCH_NHSV_RIGHTS_HISTORY_API_ID,
  (params: { account_number: string; type: NHSVRightType }) => ({
    endpoint: generateEndpoint({
      host: '/api/admin/nhsv/rights-history',
      params,
    }),
    method: 'GET',
  })
);

export default apiCall;
